import React from "react";
import "./ConfirmModal.css";

const ConfirmModal = ({ isOpen, title, message, onConfirm, onCancel, loading, confirmText = "Confirm", cancelText = "Close" }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content-confirm">
        <div className="modal-header-confirm">
          <h3 className="modal-title-confirm">{title}</h3>
          <button className="modal-close-btn" onClick={onCancel} aria-label="Close">
            ×
          </button>
        </div>
        <div className="modal-body-confirm">
          <p>{message}</p>
        </div>
        <div className="modal-footer-confirm">
          <button 
            className="btn-cancel-confirm" 
            onClick={onCancel}
            disabled={loading}
          >
            {cancelText}
          </button>
          <button 
            className="btn-confirm-confirm" 
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Processing..." : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
